<template>
  <TransitionGroup name="alerts" id="alerts-container" tag="div">
    <CAlert v-for="[key, alert] in alerts" :key="key" :color="alert.color" :dismissible="alert.dismissible">{{ alert.message }}</CAlert>
  </TransitionGroup>
</template>

<script>
import {CAlert} from "@coreui/vue";
import {mapGetters} from "vuex";
export default {
  name: "TheAlerts",
  components: {CAlert},
  computed: {
    ...mapGetters({
      alerts: 'alert/alerts'
    })
  },
}
</script>

<style lang="scss" scoped>
#alerts-container {
  position: fixed;
  top: calc(28px + .75rem);
  right: calc(24px + .75rem);
  display: flex;
  flex-direction: column;
  z-index: 1100;
}

.alerts-move,
.alerts-enter-active,
.alerts-leave-active {
  transition: all 0.5s ease;
}
.alerts-enter-from,
.alerts-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
</style>